// Pricing migration 18 (ADO-2249, Task 9.0; DEC-13 b and c): whether the session is ordering at
// the WOW entry (depot 121), where the cart shows no savings, as SL1.0 shows its savings in every
// environment except WOW (`isWOW1/isWOW2`). An entry's key is `${kind}:${depotCode}`
// (`OrderingEntry.key`), so the WOW entry's starts `WOW:`.
import { useSessionStore } from '../auth/useSessionStore';

export function isWowEntryKey(entryKey: string | null): boolean {
  return entryKey?.startsWith('WOW:') ?? false;
}

/** The session's active entry is WOW. The one place the side panel and the /cart review read
 *  "every entry except WOW" from. */
export function useIsWowEntry(): boolean {
  return useSessionStore((state) => isWowEntryKey(state.activeEntryKey));
}
